'use client';

import { SparklesIcon, BrushIcon, BotIcon, BookOpenIcon, MoonIcon, ShieldCheckIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

function FeatureCard({ icon, title, description }: FeatureCardProps) {
  return (
    <div className="feature-card group hover:scale-[1.02] transition-all duration-300">
      <div className="text-2xl mb-4 text-primary-DEFAULT2">{icon}</div>
      <h3 className="text-xl font-semibold mb-2 text-gray-900">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
}

export function ValueProposition() {
  const features = [
    {
      icon: <SparklesIcon className="h-8 w-8" />,
      title: "Tailored to Your Child's World",
      description: "Stories adapt to their name, interests, age, and even learning stage for maximum engagement."
    },
    {
      icon: <BrushIcon className="h-8 w-8" />,
      title: "Stunning Visuals",
      description: "Captivating illustrations that make each story a visual adventure your child will remember."
    },
    {
      icon: <BotIcon className="h-8 w-8" />,
      title: "AI-Powered Innovation",
      description: "Advanced technology creates unique, engaging stories in seconds, making every bedtime fresh and exciting."
    },
    {
      icon: <BookOpenIcon className="h-8 w-8" />,
      title: "Learning Through Stories",
      description: "Seamlessly blend entertainment with valuable life lessons, fostering creativity and emotional growth."
    },
    {
      icon: <MoonIcon className="h-8 w-8" />,
      title: "Bedtime-Optimized",
      description: "Specially crafted narratives that help children transition to sleep while sparking their imagination."
    },
    {
      icon: <ShieldCheckIcon className="h-8 w-8" />,
      title: "Safe & Trusted",
      description: "Carefully curated content that parents trust, designed with child development experts."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold mb-4 bg-gradient-to-r from-[#FF8B6B] to-[#FF5D3A] bg-clip-text text-transparent">
            Unlock the Magic of Personalized Bedtime
          </h2>
          <p className="text-lg text-gray-600">
            Here&apos;s Why Parents Are Raving About LullabyBunny
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
} 